module.exports = __webpack_public_path__ + "img/lapland-sign.02ebc87b.png";